import React, { useState, useContext } from 'react';
import PropTypes, { objectOf, shape } from 'prop-types';
import classNames from 'classnames';
import { VelocityComponent } from 'velocity-react';
// import i18n from '../../i18n';
import styles from './Accordion.module.scss';
import Icon from '../Icon';
import Button from '../Button';
import { TrackingContext } from '../StreamField/StreamField';
import { trackBanner } from '../../utils/datalayer';

const Accordion = ({
    id = 'accordion',
    title = '',
    content = [],
    modifiers = [],
    chevron = { size: 'medium', color: 'pink' },
}) => {
    const [isExpanded, setIsExpanded] = useState(null);
    const clickHandler = () => setIsExpanded(!isExpanded);
    const bannerLevel = useContext(TrackingContext) !== null;
    const headerId = `${id}-header`;

    const classes = classNames(
        modifiers.map((mod) => styles['Accordion--' + mod]),
        styles['Accordion']
    );

    return (
        <div className={classes}>
            <div
                className={styles['Accordion__Header']}
                onClick={clickHandler}
                aria-expanded={isExpanded}
                aria-controls={id}
                id={headerId}>
                <h3 className={styles['Accordion__Title']}>
                    {title}
                    <Icon
                        type="chevron"
                        color={chevron.color}
                        size={chevron.size}
                    />
                </h3>
            </div>
            {content.map((contents, index) => (
                <VelocityComponent
                    animation={isExpanded ? 'slideDown' : 'slideUp'}
                    key={index}>
                    <div
                        className={styles['Accordion__Content']}
                        aria-hidden={!isExpanded}
                        aria-labelledby={headerId}
                        id={id}>
                        <div className={styles['Accordion__ContentWrapper']}>
                            {contents.html ? (
                                <div
                                    className={styles['Accordion__Raw']}
                                    dangerouslySetInnerHTML={{
                                        __html: contents.html,
                                    }}></div>
                            ) : (
                                <>
                                    {!!contents.icon && (
                                        <div
                                            className={
                                                styles['Accordion__Icon']
                                            }>
                                            <Icon
                                                type={contents.icon}
                                                color="black"
                                                size="medium"
                                            />
                                        </div>
                                    )}
                                    <div>
                                        <div
                                            className={
                                                styles['Accordion__Wrapper']
                                            }>
                                            <div
                                                className={
                                                    styles[
                                                        'Accordion__ContentTextWrapper'
                                                    ]
                                                }>
                                                {!!contents.label && (
                                                    <h4
                                                        className={
                                                            styles[
                                                                'Accordion__ContentLabel'
                                                            ]
                                                        }>
                                                        {contents.label}
                                                    </h4>
                                                )}
                                                {!!contents.preamble && (
                                                    <p
                                                        className={
                                                            styles[
                                                                'Accordion__ContentPreamble'
                                                            ]
                                                        }>
                                                        {contents.preamble}
                                                    </p>
                                                )}
                                                <p
                                                    className={
                                                        styles[
                                                            'Accordion__ContentText'
                                                        ]
                                                    }>
                                                    {contents.text}
                                                </p>
                                                <div
                                                    className={
                                                        styles[
                                                            'Accordion__ContentLink'
                                                        ]
                                                    }>
                                                    {!!contents.link.href && (
                                                        <Button
                                                            href={
                                                                contents.link
                                                                    .href
                                                            }
                                                            text={
                                                                contents.link
                                                                    .label
                                                            }
                                                            type="tertiary"
                                                            icon="external"
                                                            iconSize="large"
                                                            iconColor="pink"
                                                            buttonColor="pink"
                                                            onClick={() => {
                                                                if (
                                                                    bannerLevel
                                                                ) {
                                                                    trackBanner();
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </VelocityComponent>
            ))}
        </div>
    );
};

Accordion.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    id: PropTypes.string,
    content: PropTypes.array,
    modifiers: PropTypes.array,
    chevron: PropTypes.object,
};

export default Accordion;
